
import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import SocialProof from './components/SocialProof';
import CTASection from './components/CTASection';
import ConsultationModal from './components/ConsultationModal';
import PolicyPage from './components/PolicyPage';
import CustomCursor from './components/CustomCursor';
import { ViewState } from './types';

const App: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentView, setCurrentView] = useState<ViewState>('landing');

  useEffect(() => {
    // Amplitude 페이지뷰 기록
    const amp = (window as any).amplitude;
    if (amp) {
      amp.track('view_landing_page_a');
    }

    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash === '#/privacy-policy') setCurrentView('privacy');
      else if (hash === '#/terms-of-use') setCurrentView('terms');
      else setCurrentView('landing');
      window.scrollTo(0, 0);
    };

    window.addEventListener('hashchange', handleHashChange);
    handleHashChange();

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const openModal = () => {
    const amp = (window as any).amplitude;
    if (amp) {
      amp.track('click_cta_button_a');
    }
    setIsModalOpen(true);
  };
  
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="flex flex-col min-h-screen">
      <CustomCursor />
      <Header onCtaClick={openModal} isLanding={currentView === 'landing'} />
      
      <main className="flex-grow">
        {currentView === 'landing' ? (
          <>
            <section id="hero"><Hero onCtaClick={openModal} /></section>
            <section id="problem"><Problem /></section>
            <section id="solution"><Solution /></section>
            <section id="social"><SocialProof /></section>
            <section id="cta"><CTASection onCtaClick={openModal} /></section>
          </>
        ) : (
          <PolicyPage type={currentView} />
        )}
      </main>

      <Footer />

      {isModalOpen && <ConsultationModal onClose={closeModal} />}
    </div>
  );
};

export default App;
